var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIsosceles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.12 20.932c0 8.19-6.695 14.854-14.984 14.854-8.29 0-14.984-6.664-14.984-14.854 0-8.189 6.695-14.853 14.984-14.853 8.29 0 14.984 6.664 14.984 14.853z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.219 29.736l12.92-25.95 12.92 25.95H4.22z",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}

export default SvgIsosceles;